<template>
  <v-dialog :value="visible" width="600px" @click:outside="onClose">
    <v-card>
      <v-card-title> Ändra källa </v-card-title>
      <v-card-text>
        <v-text-field class="mb-2" outlined label="Titel" v-model="link_title"></v-text-field>
        <v-text-field
          class="mb-2"
          outlined
          label="Källa"
          v-model="link_description"
          messages="T.ex. Forskning.se, Havsutsikt, etc."
        ></v-text-field>
        <v-text-field
          class="mb-2"
          outlined
          label="Länk"
          messages="https://..."
          v-model="link_url"
        ></v-text-field>
        <DatePicker
          :date="link_date_created"
          :show-icon="false"
          label="Datum"
          @change="onChangeDate"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose"> Stäng </v-btn>
        <v-btn color="primary" :loading="loading" text @click="save"> Spara </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from '../shared/DatePicker'

/* eslint camelcase: 0 */
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'EditNewsSource',
  components: {
    DatePicker,
  },
  props: {
    loading: { type: Boolean },
    source: { type: Object },
    newsId: { type: Number },
  },
  data() {
    return {
      link_description: '',
      link_title: '',
      link_url: '',
      link_date_created: moment().format('YYYY-MM-DD'),
    }
  },
  watch: {
    source: {
      handler(val) {
        if (!val) return
        this.link_description = val.link_description
        this.link_title = val.link_title
        this.link_url = val.link_url
        this.link_date_created = moment(val.link_date_created).format('YYYY-MM-DD')
      },
      deep: true,
    },
  },
  computed: {
    visible() {
      return !!this.source
    },
  },
  methods: {
    ...mapActions('links', { updateLink: 'update' }),
    ...mapActions('news', { getSingleNews: 'read' }),
    async save() {
      const { link_description, link_title, link_url, link_date_created } = this
      const payload = { ...this.source, link_description, link_title, link_url, link_date_created }
      await this.updateLink(payload)
      await this.getSingleNews({ id: this.newsId })
      this.$emit('close')
    },
    onChangeDate(date) {
      this.link_date_created = date
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.add-news-source {
  padding: 0;
  .footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
